import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { IconsModule } from '../../design/icons.module';
import { FilePickerComponent } from './file-picker.component';

@NgModule({
  declarations: [FilePickerComponent],
  imports: [CommonModule, IconsModule],
  exports: [FilePickerComponent]
})
export class FilePickerModule { }
